export const isApartment = (url) => {
	const regex = /^\/ibud\//;
	return regex.test(url);
};

export const isApplication = (url) => {
	const regex = /^\/umsokn\//;
	return regex.test(url);
};
export const isSpecialApartment = (url) => {
	const regex = /^\/grindavik\/ibud\//;
	return regex.test(url);
};

export const isSpecialApplication = (url) => {
	const regex = /^\/grindavik\/umsokn\//;
	return regex.test(url);
};

export const getType = (url) => {
	const regex = /^\/grindavik\/*/
	if (regex.test(url)){
		return 'grindavik'
	}
	return 'HMS'
}

export default function linkResolver(url) {
	if(isApplication(url)) return '/umsokn/';
	if(isApartment(url)) return '/ibud/';
	if(isSpecialApartment(url)) return '/grindavik/ibud/';
	if(isSpecialApplication(url)) return '/grindavik/umsokn/';
	if(url[url.length - 1] !== '/') return `${url}/`;
	return url;
}